import * as React from 'react';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Skeleton from '@mui/material/Skeleton';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import Button from '@mui/material/Button';
import { Box, Stack } from '@mui/material';
import API_CONSTANTS from '../resources/constants/api.json';

export default function Comments(props) {
    const useEffect = React.useEffect;
    const useState = React.useState
    const [balances, setBalances] = useState([])
    const [loading, setLoading] = useState(true)
    const [textVal, setTextVal] = useState()
    useEffect(()=>{
        fetch(`${API_CONSTANTS.API_ROUTE}/loadBalanceDetail?lease_id=${props.funcArgs.lease_id}&run_date=${props.run_date}`)
        .then((response) => {
            response.json().then(data => {
                setLoading(false)
                if (data.length === 0){
                    setBalances([{_id:0, GLAccountName:"No", Balance: "Balances", PendingBalance:''}])
                } 
                else{
                    setBalances(data);}
            })
        })
    },[])

    return (
        <Box width={"99%"} alignContent={"center"} alignItems={"center"}>
            {
                loading ?
                    <div><Skeleton /><Skeleton /><Skeleton /><Skeleton /></div>: 
                    null
            }
            <TableContainer component={Paper} 
                sx={{overflowY:'scroll', overflowX:'hidden', fontSize:8, maxHeight:175, width:"100%", paddingRight:1}}>
                <Table size="small">
                    <TableBody>
                        <TableRow>
                        <TableCell component="th" scope="row">
                                <Typography fontSize={12}>Balance Type</Typography>
                            </TableCell>
                            <TableCell component="th" scope="row">
                                <Typography fontSize={12}>Balance</Typography>
                            </TableCell>
                        </TableRow>
                        {balances.map((detail) => (
                            <TableRow key={detail._id}>
                                <TableCell component="td" scope="row">
                                    <Typography fontSize={12}>{detail.GLAccountName}</Typography>
                                </TableCell>
                                <TableCell component="td" scope="row" >
                                    <Typography fontSize={12}>{detail.Balance}</Typography>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>   
        </Box>
    )
}